import React, { useEffect } from "react";
import { useTheme } from "../../hooks/useTheme";

const AuthWrapper = ({ children }) => {
  const { theme } = useTheme();

  useEffect(() => {
    // Убедимся, что тема применяется к документу
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme]);

  return <div data-theme={theme}>{children}</div>;
};

export default AuthWrapper;
